/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_Download_CsvInputs */

const en_shared_download_csv = /** @type {(inputs: Shared_Download_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download CSV`)
};

const nl_shared_download_csv = /** @type {(inputs: Shared_Download_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV downloaden`)
};

/** @type {(inputs: Shared_Download_CsvInputs) => LocalizedString} */
const de_shared_download_csv = en_shared_download_csv;

/** @type {(inputs: Shared_Download_CsvInputs) => LocalizedString} */
const es_shared_download_csv = en_shared_download_csv;

/** @type {(inputs: Shared_Download_CsvInputs) => LocalizedString} */
const fr_shared_download_csv = en_shared_download_csv;

/** @type {(inputs: Shared_Download_CsvInputs) => LocalizedString} */
const it_shared_download_csv = en_shared_download_csv;

/** @type {(inputs: Shared_Download_CsvInputs) => LocalizedString} */
const pt_br2_shared_download_csv = en_shared_download_csv;

/** @type {(inputs: Shared_Download_CsvInputs) => LocalizedString} */
const pl_shared_download_csv = en_shared_download_csv;

/** @type {(inputs: Shared_Download_CsvInputs) => LocalizedString} */
const hu_shared_download_csv = en_shared_download_csv;

/** @type {(inputs: Shared_Download_CsvInputs) => LocalizedString} */
const ro_shared_download_csv = en_shared_download_csv;

/**
* | output |
* | --- |
* | "Download CSV" |
*
* @param {Shared_Download_CsvInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_download_csv = /** @type {((inputs?: Shared_Download_CsvInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_Download_CsvInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_download_csv(inputs)
	if (locale === "de") return de_shared_download_csv(inputs)
	if (locale === "es") return es_shared_download_csv(inputs)
	if (locale === "fr") return fr_shared_download_csv(inputs)
	if (locale === "nl") return nl_shared_download_csv(inputs)
	if (locale === "it") return it_shared_download_csv(inputs)
	if (locale === "pt-BR") return pt_br2_shared_download_csv(inputs)
	if (locale === "pl") return pl_shared_download_csv(inputs)
	if (locale === "hu") return hu_shared_download_csv(inputs)
	return ro_shared_download_csv(inputs)
});
export { shared_download_csv as "shared.download_csv" }